export const env = {
  debug: false,
  basePath: "https://www.musthavemenus.com",
  apiPath: "https://www.musthavemenus.com/home/api",
  dashboardPath: "/home",
  rendererPath: "https://renderer.mhmcdn.com",
  videoRendererPath: "https://video-renderer.mhme.nu",
  lpContextPath: "",
  ooContextPath: "/oo/app",
  timberContextPath: "/x",
  accountContextPath: "https://www.musthavemenus.com/account",
  s3Path: "https://mhm-timber.s3.amazonaws.com",
  intercomAppId: "rmer2hwk",
  hCaptchaKey: "3355cf01-fc2a-4b92-8703-84929f384a3e",
  reCaptchaKey: "6Ldt8JweAAAAAMurFH0laJJzlb-QanZ0Sg5WshzC",
  printApiPath: "https://print.mhmcdn.com/api",
  stripeKey: "pk_live_51LNJklJ6o5U09Rqh0eq0g2juxoXIkmRomN6uX76oP8mKtvdTdv5V7NxlbYPayqNQYVIt4X4tNPcrZGa90KRbkv9K00T9qV2uzR",
  env: 'prod'
};
